<div class="w-full mx-auto p-5 space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center">
    <div>
      <button (click)="goBack()" class="text-blue-600 hover:text-blue-800 mb-2 flex items-center gap-2">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
        Volver a URLs de Relay
      </button>
      <h1 class="text-2xl font-bold text-gray-800">Logs de Relay</h1>
      <p class="text-gray-500 mt-1">{{ relayUrlName }}</p>
    </div>
    <div *ngIf="totalCount > 0" class="text-sm text-gray-500">
      {{ totalCount }} registros totales
    </div>
  </div>

  <!-- Búsqueda y Filtros -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 space-y-4">
    <!-- Barra de búsqueda -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Buscar por Transaction ID o Link ID</label>
      <div class="relative">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
               placeholder="Ej: 190093-1773265175-82664, pl_xxxx..."
               class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>
    </div>

    <!-- Filtros adicionales -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <!-- Filtro de Éxito -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Estado</label>
        <select [(ngModel)]="successFilter" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
          <option [ngValue]="null">Todos</option>
          <option [ngValue]="true">Exitosos</option>
          <option [ngValue]="false">Fallidos</option>
        </select>
      </div>

      <!-- Fecha Desde -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Desde</label>
        <input type="datetime-local" [(ngModel)]="fromDate"
               class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
      </div>

      <!-- Fecha Hasta -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Hasta</label>
        <input type="datetime-local" [(ngModel)]="toDate"
               class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
      </div>
    </div>

    <div class="flex justify-end gap-3">
      <button (click)="clearFilters()" class="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">
        Limpiar Filtros
      </button>
      <button (click)="applyFilters()" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
        Aplicar Filtros
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center py-12">
    <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
  </div>

  <!-- Tabla de Logs -->
  <div *ngIf="!loading" class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
    <div class="overflow-x-auto">
      <table class="w-full">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Fecha</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Estado</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">HTTP</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Transaction ID</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Payment Link</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Duración</th>
            <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          <ng-container *ngFor="let log of logs">
            <!-- Fila Principal -->
            <tr class="hover:bg-gray-50 transition cursor-pointer" (click)="toggleLogDetails(log.id)">
              <td class="px-4 py-3 text-sm text-gray-800">
                {{ formatDate(log.requestSentAt) }}
              </td>
              <td class="px-4 py-3">
                <span class="px-3 py-1 text-xs font-medium rounded-full"
                      [ngClass]="log.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                  {{ log.success ? 'Exitoso' : 'Fallido' }}
                </span>
              </td>
              <td class="px-4 py-3">
                <span class="px-2 py-1 text-xs font-medium rounded-full"
                      [ngClass]="getStatusClass(log.httpStatusCode)">
                  {{ log.httpStatusCode || 'N/A' }}
                </span>
              </td>
              <td class="px-4 py-3 text-sm text-gray-600 font-mono">
                <span *ngIf="log.wompiTransactionId" class="truncate block max-w-[180px]" [title]="log.wompiTransactionId">{{ log.wompiTransactionId }}</span>
                <span *ngIf="!log.wompiTransactionId" class="text-gray-400">N/A</span>
              </td>
              <td class="px-4 py-3 text-sm text-gray-600 font-mono">
                <span *ngIf="log.wompiPaymentLinkId" class="truncate block max-w-[140px]" [title]="log.wompiPaymentLinkId">{{ log.wompiPaymentLinkId }}</span>
                <span *ngIf="!log.wompiPaymentLinkId" class="text-gray-400">N/A</span>
              </td>
              <td class="px-4 py-3 text-sm text-gray-800">
                {{ formatDuration(log.durationMs) }}
              </td>
              <td class="px-4 py-3">
                <button class="text-blue-600 hover:text-blue-800">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          [attr.d]="isExpanded(log.id) ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'"/>
                  </svg>
                </button>
              </td>
            </tr>

            <!-- Fila Expandida con Detalles -->
            <tr *ngIf="isExpanded(log.id)" class="bg-gray-50">
              <td colspan="7" class="px-4 py-4">
                <div class="space-y-4">

                  <!-- Error Message si existe -->
                  <div *ngIf="log.errorMessage" class="bg-red-50 border border-red-200 rounded-lg p-4">
                    <h4 class="text-sm font-semibold text-red-800 mb-2">Error</h4>
                    <p class="text-sm text-red-700">{{ log.errorMessage }}</p>
                  </div>

                  <!-- Request -->
                  <div class="bg-white border border-gray-200 rounded-lg p-4">
                    <h4 class="text-sm font-semibold text-gray-800 mb-2">Request Body</h4>
                    <pre class="text-xs text-gray-700 overflow-x-auto bg-gray-100 p-3 rounded max-h-96 overflow-y-auto">{{ prettyPrintJson(log.requestBody) }}</pre>
                  </div>

                  <!-- Request Headers -->
                  <div class="bg-white border border-gray-200 rounded-lg p-4">
                    <h4 class="text-sm font-semibold text-gray-800 mb-2">Request Headers</h4>
                    <pre class="text-xs text-gray-700 overflow-x-auto bg-gray-100 p-3 rounded">{{ prettyPrintJson(log.requestHeaders) }}</pre>
                  </div>

                  <!-- Response -->
                  <div *ngIf="log.responseBody" class="bg-white border border-gray-200 rounded-lg p-4">
                    <h4 class="text-sm font-semibold text-gray-800 mb-2">Response Body</h4>
                    <pre class="text-xs text-gray-700 overflow-x-auto bg-gray-100 p-3 rounded max-h-96 overflow-y-auto">{{ prettyPrintJson(log.responseBody) }}</pre>
                  </div>

                  <!-- Response Headers -->
                  <div *ngIf="log.responseHeaders" class="bg-white border border-gray-200 rounded-lg p-4">
                    <h4 class="text-sm font-semibold text-gray-800 mb-2">Response Headers</h4>
                    <pre class="text-xs text-gray-700 overflow-x-auto bg-gray-100 p-3 rounded">{{ prettyPrintJson(log.responseHeaders) }}</pre>
                  </div>

                  <!-- Información Adicional -->
                  <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div class="bg-white border border-gray-200 rounded-lg p-3">
                      <p class="text-xs text-gray-500">Transaction ID</p>
                      <p class="text-sm font-semibold text-gray-800 font-mono break-all">{{ log.wompiTransactionId || 'N/A' }}</p>
                    </div>
                    <div class="bg-white border border-gray-200 rounded-lg p-3">
                      <p class="text-xs text-gray-500">Payment Link ID</p>
                      <p class="text-sm font-semibold text-gray-800 font-mono break-all">{{ log.wompiPaymentLinkId || 'N/A' }}</p>
                    </div>
                    <div class="bg-white border border-gray-200 rounded-lg p-3">
                      <p class="text-xs text-gray-500">Webhook Request ID</p>
                      <p class="text-sm font-semibold text-gray-800">{{ log.webhookRequestId || 'N/A' }}</p>
                    </div>
                    <div class="bg-white border border-gray-200 rounded-lg p-3">
                      <p class="text-xs text-gray-500">Intento</p>
                      <p class="text-sm font-semibold text-gray-800">{{ log.attemptNumber }}</p>
                    </div>
                    <div class="bg-white border border-gray-200 rounded-lg p-3">
                      <p class="text-xs text-gray-500">Enviado</p>
                      <p class="text-sm font-semibold text-gray-800">{{ formatDate(log.requestSentAt) }}</p>
                    </div>
                    <div class="bg-white border border-gray-200 rounded-lg p-3">
                      <p class="text-xs text-gray-500">Recibido</p>
                      <p class="text-sm font-semibold text-gray-800">{{ log.responseReceivedAt ? formatDate(log.responseReceivedAt) : 'N/A' }}</p>
                    </div>
                    <div class="bg-white border border-gray-200 rounded-lg p-3">
                      <p class="text-xs text-gray-500">URL Destino</p>
                      <p class="text-sm font-semibold text-gray-800 truncate" [title]="log.targetUrl">{{ log.targetUrl }}</p>
                    </div>
                  </div>

                </div>
              </td>
            </tr>
          </ng-container>

          <tr *ngIf="logs.length === 0 && !loading">
            <td colspan="7" class="px-4 py-8 text-center text-gray-500">
              <svg class="w-12 h-12 mx-auto text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
              No se encontraron logs{{ searchTerm ? ' para "' + searchTerm + '"' : '' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div *ngIf="totalPages > 1" class="flex items-center justify-between px-4 py-3 bg-gray-50 border-t border-gray-200">
      <div class="text-sm text-gray-600">
        Mostrando {{ firstItemOnPage }} - {{ lastItemOnPage }} de {{ totalCount }}
      </div>
      <div class="flex items-center gap-1">
        <!-- Primera página -->
        <button (click)="goToPage(1)" [disabled]="!hasPreviousPage"
                class="px-2 py-1 text-sm rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"/>
          </svg>
        </button>
        <!-- Anterior -->
        <button (click)="previousPage()" [disabled]="!hasPreviousPage"
                class="px-2 py-1 text-sm rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        <!-- Números de página -->
        <button *ngFor="let page of getPageNumbers()" (click)="goToPage(page)"
                class="px-3 py-1 text-sm rounded border"
                [ngClass]="page === pageNumber ? 'bg-blue-600 text-white border-blue-600' : 'border-gray-300 hover:bg-gray-100'">
          {{ page }}
        </button>
        <!-- Siguiente -->
        <button (click)="nextPage()" [disabled]="!hasNextPage"
                class="px-2 py-1 text-sm rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
        <!-- Última página -->
        <button (click)="goToPage(totalPages)" [disabled]="!hasNextPage"
                class="px-2 py-1 text-sm rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
